import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class DigitalWaiverWidgetService{
    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) {}

    getDigitalWaiverEntry(apiKey: string, id: string): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.get(`${this.url}/digitalwaiverwidget/${id}`, { headers: headers });
    }

    getUserOrganization(apiKey: string): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.get(`${this.url}/digitalwaiverwidget/organization`, { headers: headers });
    }

    getActiveDigitalWaiver(organizationId: string, apiKey: string): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.get(`${this.url}/digitalwaiverwidget/organization/${organizationId}/active`, { headers: headers });
    }

    createDigitalWaiverEntry(apiKey: string, data: any): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/digitalwaiverwidget/create`, data, { headers: headers });
    }

    updateDigitalWaiverEntry(apiKey: string, data: any): any {
        const headers = new HttpHeaders({
            'ApiKey': apiKey
        });

        return this.http.post(`${this.url}/digitalwaiverwidget/update`, data, { headers: headers });
    }
}